export const messages = {
  seeLibrary: {
    id: "tooltip.see-library",
    defaultMessage: "See library",
  },
};
